<template>
<div v-if="!isLoading">
  <div v-if="isSuper" class="rewardCard__notification">
    <div class="flex justify-between">
      <div class="text-sm font-bold os-tag os-tag-full os-tag-solid os-tag-orange mt-0 mb-8">獲得</div>
      <div class="cursor-pointer" @click="closeNotification">
        <i class="owl-status-error"></i>
      </div>
    </div>
    <div class="text-lg leading-lg font-bold">恭喜！您已獲得免費住宿優惠券</div>
    <div class="text-sm font-bold leading-lg">免費優惠券已放入可使用優惠券中，集點將重新累積</div>
  </div>
  <div class="rewardCard mb-16 mx-16 md:mx-0 md:mb-40">
    <div class="column">
      <div class="border-b xl:border-b-0 xl:border-r border-grey-dark h-full pb-16 xl:pb-0 xl:pr-16 mb-16 xl:mb-0 xl:mr-24">
        <!-- <div v-if="isLogin">Hi, {{ userNickname }}</div> -->
        <template v-if="msg">
          <div class="text-xl font-bold leading-xl mt-8">{{ $t('rewardCard.newSlogan') }}</div>
          <!-- <div class="text-sm font-bold leading-sm mt-8">{{ msg.desc }}</div> -->
          <div class="my-8 flex items-center font-bold">
            <!-- <img class="mr-8" height="14" width="11" src="@/assets/images/icon-stayNight.svg" alt="stay night"> -->
            <span :class="['text-sm sm:text-base', selectedLang === 'en' && 'reward-desp']">{{ $t('rewardCard.stay.5') }}</span>
            <i class="owl owl-direction-right" />
            <span class="text-sm text-white py-4 px-8 bg-orange rounded-sm">{{ $t('rewardCard.half') }}</span>
          </div>
          <div class="flex items-center font-bold">
            <div class="border-t-2 border-grey py-12">
              <!-- <img class="mr-8" height="14" width="11" src="@/assets/images/icon-stayNight.svg" alt="stay night"> -->
              <span :class="['text-sm sm:text-base', selectedLang === 'en' && 'reward-desp']">{{ $t('rewardCard.stay.8') }}</span>
              <i class="owl owl-direction-right" />
              <span class="text-sm text-white py-4 px-8 bg-orange rounded-sm">{{ $t('rewardCard.free') }}</span>
            </div>
          </div>
          <div class="flex mt-16">
            <button v-if="msg.terms" @click="onClickTerm" class="btn btn-sm btn-ghost btn-black fix-active">{{ $t('eventDescription') }}</button>
            <button v-if="msg.exchange" @click="onClickExchange" class="btn btn-sm btn-solid bg-orange-dark">{{ $t('redemptionCoupon') }}</button>
          </div>
        </template>
      </div>
    </div>
    <div class="column">
      <div class="text-xl font-bold mt-8">
        <div v-if="msg">
          <div class="text-xl font-bold leading-xl mt-8">{{ msg.title }}</div>
          <div class="text-sm font-bold leading-sm">{{ msg.desc }}</div>
        </div>
        <span v-else>{{ $t('rewardCard.title.default') }}</span>
      </div>
      <section class="points-wrap">
        <div v-for="day in 8" :key="day">
          <div class="point" :class="pointClass(day)" :data-percent="percentText(day)">
            <div class="number">{{ day }}</div>
          </div>
        </div>
        <div class="free-ticket">FREE</div>
      </section>
      <div v-if="isSuper" class="mt-64">
        <input type="range" min="0" max="8" step="1" v-model="accumulationDays" class="w-full">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import fullPageModal from '@/components/modals/fullPageModal'
import pointEventInfo from '@/components/pointEventInfo'
// import commonProblem from '@/components/commonProblem'
import couponPreview from '@/components/couponPreview'

export default {
  name: 'rewardCard',
  props: {
    inPoints: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: true,
      accumulationDays: 0,
      status: {
        'default': {
          title: this.$t('rewardCard.title.default'),
          desc: this.$t('rewardCard.desc.default'),
          terms: true,
          exchange: false
        },
        0: {
          title: this.$t('rewardCard.title[0]'),
          desc: this.$t('rewardCard.desc[0]'),
          terms: true,
          exchange: false
        },
        1: {
          title: this.$t('rewardCard.title[1]'),
          desc: this.$t('rewardCard.desc[1]'),
          terms: true,
          exchange: false
        },
        2: {
          title: this.$t('rewardCard.title[2]'),
          desc: this.$t('rewardCard.desc[2]'),
          terms: true,
          exchange: false
        },
        3: {
          title: this.$t('rewardCard.title[3]'),
          desc: this.$t('rewardCard.desc[3]'),
          terms: true,
          exchange: false
        },
        4: {
          title: this.$t('rewardCard.title[4]'),
          desc: this.$t('rewardCard.desc[4]'),
          terms: true,
          exchange: false
        },
        5: {
          title: this.$t('rewardCard.title[5]'),
          desc: this.$t('rewardCard.desc[5]'),
          terms: true,
          exchange: true
        },
        6: {
          title: this.$t('rewardCard.title[6]'),
          desc: this.$t('rewardCard.desc[6]'),
          terms: true,
          exchange: true
        },
        7: {
          title: this.$t('rewardCard.title[7]'),
          desc: this.$t('rewardCard.desc[7]'),
          terms: true,
          exchange: true
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isSuper: 'isSuper',
      isLogin: 'user/isLogin',
      profile: 'user/profile',
      selectedLang: 'user/selectedLang'
    }),
    userNickname: function () {
      return this.profile?.nickname ?? ''
    },
    freeNight () {
      return ~~(this.accumulationDays / 8)
    },
    unconvertedNight: function () {
      return this.accumulationDays % 8
    },
    msg: function () {
      if (this.isLogin) {
        return this.status[this.unconvertedNight]
      }
      return this.status['default']
    }
  },
  methods: {
    ...mapActions({
      getNight: 'user/getNight',
      getCoupons: 'user/getCoupons'
    }),
    closeNotification: function () {
      alert('closeNotification')
    },
    pointClass: function (day) {
      return {
        'activated': day <= this.unconvertedNight,
        'rightTicket': day === 6
      }
    },
    onClickTerm: function () {
      this.$modal.show(fullPageModal, {
        context: pointEventInfo
      },
      {
        adaptive: true,
        name: 'pointEventInfo',
        width: '60%',
        height: '85%',
        minWidth: 375,
        scrollable: true
      })
    },
    onClickExchange: function () {
      this.$modal.show(fullPageModal,
        {
          context: couponPreview,
          data: {
            callback: () => {
              this.getCoupons()
              this.getNight().then(res => {
                this.accumulationDays = Number(res.data.count) || 0
                this.isLoading = false
              })
              this.$message({
                message: this.$t('rewardCard.success'),
                type: 'success'
              })
              this.$modal.hide('couponPreview')
              if (this.inPoints) {
                this.$emit('success')
              }
            }
          }
        },
        {
          adaptive: true,
          name: 'couponPreview',
          clickToClose: true,
          height: 'auto',
          width: '60%',
          minWidth: 375,
          scrollable: true
        }
      )
    },
    percentText: function (day) {
      if (day === 6) {
        return '50% off'
      }
    }
  },
  created () {
    this.getNight().then(res => {
      this.accumulationDays = Number(res.data.count) || 0
      this.isLoading = false
    })
  }
}
</script>

<style lang="sass" scoped>
.rewardCard
  @apply flex flex-col p-16
  border-radius: 1.25rem
  background:
    size: 100% 100%
    repeat: no-repeat
  background-color: #eee7dc
  background-image: linear-gradient(140deg, #f3ece5 0%, #eee7dc 50%, #cab394 100%)
  background-image: -webkit-image-set(url('~@/assets/rewardCard/reward-bg--mobile.webp'))
  min-height: 427px
  @screen xl
    @apply flex flex-row p-24
    background-image: -webkit-image-set(url('~@/assets/rewardCard/reward-bg.webp'))
    min-height: 222px
  .column
    &:first-child
      @screen sm
        min-width: 300px
    &:last-child
      @screen xl
        min-width: 570px
    .reward-desp
      @screen sm
        min-width: 101px
  .btn
    @apply px-16
    & + .btn
      @apply ml-16
  .points-wrap
    min-height: 80px
    margin: 0 -12px
    @apply flex flex-wrap mt-16
    @screen lg
      @apply my-16 items-start
    .point
      @apply rounded-full relative
      @apply border border-2 border-white bg-white
      @apply font-bold text-xl mb-16 mx-12
      width: 40px
      height: 40px
      transition: all 0.3s ease
      .number
        @apply absolute text-sm flex items-center justify-center
        @apply rounded-full
        @apply border border-1 border-white
        transition: all 0.3s ease
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        width: 32px
        height: 32px
        z-index: 3
      &:before, &:after
        transition: all 0.3s ease
      &.activated
        @apply bg-white
        @apply border-white
        .number
          @apply bg-orange border-orange
          @apply text-white
        &.rightTicket
          @apply border-orange
          .number
            @apply text-white
            @apply bg-orange
            @apply border-white
          &:after
            background:
              image: url('~@/assets/rewardCard/reward-flag--activated.svg')
            @apply text-white
      &.rightTicket
        @apply border-orange
        margin-right: 76px
        @screen lg
          margin-right: 12px
        .number
          @apply bg-white border-white
          @apply text-orange-dark
        &:before
          content: ''
          @apply absolute block
          @apply bg-orange
          top: 50%
          left: 100%
          transform: translateY(-50%)
          width: 18px
          height: 2px
          @screen lg
            top: 100%
            left: 50%
            transform: translateX(-50%)
            width: 2px
            height: 18px
        &:after
          content: attr(data-percent)
          @apply absolute block text-sm font-bold
          background:
            size: 100% 100%
            image: url('~@/assets/rewardCard/reward-flag.svg')
          width: 55px
          height: 46px
          @apply flex items-center justify-center pl-8 text-orange-dark
          top: 50%
          left: calc(100% + 16px)
          transform: translateY(-50%)
          @screen lg
            top: calc(100% + 16px)
            left: 50%
            transform: translateX(-50%)
    .free-ticket
      @apply bg-contain bg-no-repeat bg-center flex font-bold items-center text-orange-dark
      background-image: url('~@/assets/rewardCard/reward-flag.svg')
      padding-left: 6px
      height: 42px
      width: 55px
  &__notification
    @apply relative overflow-hidden
    @apply border border-grey-lightest py-24 px-32 shadow rounded-sm mb-16
    background:
      image: url('~@/assets/rewardCard/rewardCard-notification-bg.svg')
      position: left
      repeat: no-repeat
      size: contain
    &:before
      content: ''
      @apply block absolute
      @apply border-l border-orange
      border-width: 4px
      @apply h-full
      top: 0
      left: 0
.fix-active:active
  @apply text-black #{!important}
</style>
